<div class="sticky top-16 z-[30] bg-white pb-2">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>
            {{ item }}
          </strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">
            {{ item }}
          </button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>

    <button [routerLink]="['/admin/client']" appearance="secondary" tuiButton type="button" style="border: 2px solid #E5E7EA; font-weight: 800;">
      View All Clients
    </button>
  </nav>

  <div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Expiring Soon (7 days)</p>
    <div class="flex items-center mt-5 space-x-4">
      <input title="Archived switch" tuiSwitch type="checkbox" [(ngModel)]="filters.archived" (change)="applyFilters({ archived: filters.archived })" />
      <div>
        <p class="text-sm font-medium text-[#191C30E5] my-0">Show Archived</p>
      </div>
    </div>
  </div>

  <search class="lg:w-[50%] xl:w-[50%] 2xl:w-[40%]" tuiSearch style="padding-left: 0">
    <fieldset class="border-none" tuiTextfieldSize="m" style="padding-left: 0">
      <div class="flex items-center space-x-4">
        <div class="w-[431px]">
          <tui-textfield iconStart="@tui.search">
            <input [(ngModel)]="filters.searchText" placeholder="Search" (keydown)="onEnter($event)" placeholder="Search Expiring Clients" tuiTextfield />
          </tui-textfield>
        </div>
        <!-- dropDown -->
        <div class="w-[180px]">
          <tui-combo-box [stringify]="stringify" [(ngModel)]="filters.status" (ngModelChange)="applyFilters({ status: filters.status })">
            Status
            <input tuiTextfieldLegacy placeholder="Select status" [value]="stringify(filters.status)" />
            <tui-data-list-wrapper *tuiDataList [items]="items" [itemContent]="stringify | tuiStringifyContent" />
          </tui-combo-box>
        </div>
         <button (click)="loadExpiredClients()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
          style="border: 2px solid #e5e7ea; font-weight: 800">
          Search
        </button>
      </div>
    </fieldset>
    <fieldset class="flex items-center space-x-4 border-none" style="padding-left: 0">
      <p class="text-sm font-semibold text-[#26293C]">
        Showing results for "{{ filters.searchText || "All Expiring Clients" }}"
      </p>
      <button appearance="flat" iconStart="@tui.rotate-cw" size="xs" tuiButton type="reset" (click)="clearSearch()">
        Clear
      </button>
    </fieldset>
  </search>
</div>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<div *ngIf="!isLoading && clientData && clientData.length === 0" class="text-center py-10">
  <p class="text-lg text-gray-600">No expiring clients found</p>
</div>

<div *ngIf="!isLoading && clientData && clientData.length > 0" class="w-full mt-5 overflow-x-scroll">
  <table tuiTable [size]="size" class="w-full min-w-[1000px]">
    <thead>
      <tr>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Client Registration Number
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Client Name
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Patient Name
        </th>
        
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Client Contact No
        </th>
           <th tuiTh style="
            padding: 0;
            padding-left: 20px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Status
        </th>
               <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Expiry Date
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Expiry Status
        </th>
      
     
        <!-- <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Created Date
        </th> -->
   
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            z-index: -10;
          ">
          Actions
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let user of clientData">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p [routerLink]="['/admin/client/', user._id]" class="text-[#526ED3] text-sm cursor-pointer">
              {{ listRowClientId(user) }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.guardianName }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user.name }}</p>
          </div>
        </td>
        
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ user?.guardianContactNo }}
            </p>
          </div>
        </td>
          <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center w-[75px] py-2 rounded-full text-white" [style.background-color]="user.active ? '#6BC68A' : 'red'">
            {{ user.active ? "Active" : "Inactive" }}
          </p>
        </td>
            <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p [ngClass]="{
              'text-red-600': getExpiryStatus(user.expiryDate) === 'expired',
              'text-orange-600': getExpiryStatus(user.expiryDate) === 'expiring-soon'
            }" class="font-semibold text-sm">
              {{ user.expiryDate | date : "MMM d, y" }}
            </p>
          </div>
        </td>
       
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p *ngIf="getDaysRemaining(user.expiryDate) < 0" class="text-center w-[100px] py-2 rounded-full text-white bg-red-600 font-semibold text-sm">
              Expired
            </p>
            <p *ngIf="getDaysRemaining(user.expiryDate) >= 0" class="text-center w-[120px] py-2 rounded-full text-white bg-orange-500 font-semibold text-sm">
              {{ getDaysRemaining(user.expiryDate) }} day(s) left
            </p>
          </div>
        </td>
      
        <!-- <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ user.createdAt | date : "MMM d, y" }}
            </p>
          </div>
        </td> -->
     
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <span tuiStatus class="flex flex-wrap items-center gap-2">
            <button
              appearance="primary"
              size="xs"
              tuiButton
              type="button"
              [disabled]="user?.archived || !loggedInUserCanEdit"
              (click)="openRenewDialog(user)"
              [appDisableUnlessPermission]="'CLIENT_UPDATE'"
            >
              Renew
            </button>
            <p [routerLink]="['/admin/client/', user._id]" class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer m-0">
              View
            </p>
            <div>
              <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button" [tuiAppearanceState]="openMap[user._id] ? 'hover' : null" [tuiDropdown]="content" [disabled]="!loggedInUserCanEdit" [style.color]="!loggedInUserCanEdit ? '#a6afce' : '#526ED3'" [(tuiDropdownOpen)]="openMap[user._id]" (click)="toggleDropdown(user._id)">
                More
              </button>
              <ng-template #content>
                <tui-data-list tuiDataListDropdownManager [size]="openDropdownsize">
                  <button
                    style="color: black"
                    class="dropdown-button"
                    tuiOption
                    type="button"
                    [routerLink]="['/admin/client/add-edit', user._id]"
                    [disabled]="user?.archived"
                  >
                    Edit
                  </button>
                  <button style="color: black" class="dropdown-button" tuiOption type="button" (click)="resetUserPassword(user?.email)">
                    Reset Password
                  </button>
                  <button style="color: black" class="dropdown-button" tuiOption type="button" (click)="toggleActive(user?._id)">
                    {{ user?.active ? "Deactivate" : "Activate" }}
                  </button>
                  <button
                    *ngIf="!user?.archived || canUnarchiveClient(user)"
                    style="color: black"
                    class="dropdown-button"
                    tuiOption
                    type="button"
                    (click)="toggleArchive(user?._id)"
                  >
                    {{ user?.archived ? "Unarchive" : "Archive" }}
                  </button>
                </tui-data-list>
              </ng-template>
            </div>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination Controls -->
<div *ngIf="!isLoading && clientData && clientData.length > 0" class="flex justify-end items-center mt-5">
  <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
  </tui-pagination>
</div>

<app-record-renewal-dialog
  [open]="renewDialogOpen"
  [client]="renewClientTarget"
  [busy]="renewBusy"
  (openChange)="renewDialogOpen = $event"
  (confirm)="onRenewConfirm($event)"
/>
